// extracted by mini-css-extract-plugin
export default {"rich-text-editor":"R1gW48","rich-text-editor__h3":"KaLZcr"};